import styled from 'styled-components';

export const ButtonStyled = styled.button`
    font-size: large;
    font-weight: bolder;
    font-family: monospace;
    width: 10rem;
    color: #292c27e3;
    background-color: rgb(20, 216, 20);
    padding: 2vh;
    border-radius: 1vh;
    margin: auto 2vh;
    box-shadow: inset -1px -1px 3px 3px #0c4804, 0px 0px 8px 0px #33e91a;
`;
